import RoutingActions from '../../../actions/RoutingActions';
import GuestListActions from '../../../actions/GuestListActions';
import PopupActions from '../../../actions/PopupActions';
import NotificationActions from '../../../actions/NotificationActions';
import UserStore from '../../../stores/UserStore';
import UserActions from '../../../actions/UserActions';

class CheckIn extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        };

        this.checkGuestIn = this.checkGuestIn.bind(this);
        this.validate = this.validate.bind(this);
    }

    validate() {
        var { guest } = this.props;

		if(!!UserStore.getState().selectedLocation.RequireDoctorForCheckIn) {
			if(!(parseInt(guest.doctor) > 0)) {
	            NotificationActions.addNotification({
	                type : 'alert',
	                body : 'Patient does not have a doctor on record.'
				});
				return false;
			}
        }   
        
        if (!guest.CustomerTypeId) {
            NotificationActions.addNotification({
                type : 'alert',
                body : 'Patient does not have a customer type on record.'
            });
            return false;
        }

        if (!UserStore.getState().selectedLocation.AllowInvalidCustomerCheckIn) {
            var validationObject = {};
            validationObject.CustomerTypeId= guest.CustomerTypeId;
            validationObject.ReferralSourceId = guest.ReferralSourceId ;
            validationObject.Status = guest.status;
            validationObject.fullName = guest.FullName;
            validationObject.dob = guest.DOB;
            validationObject.phone = guest.PhoneNo;
            validationObject.cellPhone = guest.CellPhone;
            validationObject.email = guest.Email;
            validationObject.city = guest.address.city;
            validationObject.postal_code = guest.address.postal_code;
            validationObject.county = guest.address.state;

            guest.identifications.forEach(id => {
                if (id.type === 'DriversLicenseId') {
                    validationObject.driver_license_id = id.number;
                    validationObject.driver_license_id_exp = id.ExpirationDate
                }
            })

            var validationError = UserStore.getFormError('Customer Profile (POS)', validationObject);
            if (validationError) {
                NotificationActions.addNotification({
                    type : 'alert',
                    body : validationError
                });
                return false;
            }
        }

        if (this.props.guest.status != 'Active') {
            NotificationActions.addNotification({
                type : 'alert',
                body : 'Patient is ' + this.props.guest.status + '.'
            });
            return true;
        }

        return true;
    }

	checkGuestIn(valid) {       
        const selectedLocation = UserStore.getState().selectedLocation;
        const guest = this.props.guest;

		if (this.state.loading || !this.validate()) {
            return;
        }

        if (!valid) {
            return;
        }

        let expirationDateError = false;

        if (selectedLocation.RequireValidDL
            && UserStore.isFieldRequired('Customer Profile (POS)', 'driver_license_id')
            && UserStore.isFieldRequired('Customer Profile (POS)', 'driver_license_id_exp')
            && UserActions.isDriversLicenseExpired(this.props.guest)) {

            expirationDateError = true;
            NotificationActions.error('Patient\'s Driver\'s License has expired.');
        }

        if (selectedLocation.MMJIdExpirationDateCheck && guest.IsMedical
            && UserActions.isMMJLicenseExpired(this.props.guest)) {
            
            expirationDateError = true;
            NotificationActions.error('Patient\'s MMJ License has expired.');
        }

        if (selectedLocation.MMJIdExpirationDateCheck && guest.IsMedical &&
            selectedLocation.NotifyCard30DayExpiration && UserActions.isMMJLicenseAboutExpire(this.props.guest)) {
            const days = UserActions.mmjLicenseDaysFromExpiration(this.props.guest);
            NotificationActions.warn(`Patient\'s MMJ License is about to expire in ${days} days.`);
        }

        const minorAge = UserActions.getMinorAge(selectedLocation, this.props.guest.IsMedical)
        if (selectedLocation.BlockMinorsFromCheckInFF && UserActions.checkMinorStatus(this.props.guest, minorAge)) {

            NotificationActions.error(`Patient is under the age of ${minorAge}. You cannot proceed`);
            return;
        }

        if (expirationDateError) {
            return;
        }

        this.setState({ loading : true });
        //Does this logic belong to the action?
        GuestListActions.checkGuestIn(this.props.guest, false)
            .then(() =>{
                this.setState({ loading : false });
                GuestListActions.loadGuestList(false);
                RoutingActions.updateRoute('guest-list');
                PopupActions.close();  //  TODO: ytho?
            })
            .catch(() => {
                this.setState({ loading : false });
            });
    }

    render() {
        var label = this.props.selectedLocation.CompanyFlag === 'Dispensary' ? 'CHECK GUEST IN' : 'CHECK CUSTOMER IN';
        var valid = !(this.props.selectedLocation.BlockBannedPatientCheckin && this.props.guest.status == 'Banned');

        return (
            <button
                className={'btn-green '+(!valid ? 'btn-green__disabled' : '')}
                onClick={() => this.checkGuestIn(valid)}
				disabled={false}
			>
                { this.props.loading ? 'Loading' : label }
            </button>
        );
    }
}

export default CheckIn;


// WEBPACK FOOTER //
// ./ui_src/app/components/profile/sidebar/CheckIn.react.jsx